<template>
  <section class="table">
    <!-- BU SAYFADAKİ TABLOLAR WORDDEN TEXT EDİTORE KOPYALANARAK SAYFAYA EKLENMISTIR O YÜZDEN INLINE STYLELAR MEVCUT -->
    <v-container>
      <h2 class="pt-10">Araç Kasko Sigortası Fiyatları</h2>
      <p class="mt-5">
        Size en iyi fiyatı bulmak için 20’den fazla sigorta şirketini
        karşılaştırıyoruz.
      </p>
      <template>
        <v-toolbar flat class="mb-10">
          <template v-slot:extension>
            <v-tabs
              v-model="tab"
              align-with-title
              active-class="category-table-tab--active"
            >
              <v-tabs-slider color="green"></v-tabs-slider>

              <v-row no-gutters class="justify-center">
                <v-tab
                  class="category-table-tab mx-10"
                  v-for="btn in buttons"
                  :key="btn.id"
                >
                  <h3>{{ btn.text }}</h3>
                </v-tab>
              </v-row>
            </v-tabs>
          </template>
        </v-toolbar>
        <v-container>
          <v-row class="mt-5">
            <v-col cols="12" class="justify-space-between d-flex">
              <span class="table--info">Araç Türü: Otomobil</span>
              <span class="table--info"
                >{{ currentYear }} Trafik Sigortası Fiyatları</span
              >
            </v-col>
          </v-row>
        </v-container>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <table>
              <tbody>
                <tr>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong
                        ><span style="color: #92D050;">Marka</span></strong
                      >
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong
                        ><span style="color: #92D050;">Model Yılı</span></strong
                      >
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong
                        ><span style="color: #92D050;">Model</span></strong
                      >
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong
                        ><span style="color: #92D050;"
                          >Araç Kasko Değeri (Ortalama Araç Değeri)</span
                        ></strong
                      >
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong
                        ><span style="color: #92D050;"
                          >Hasarsızlık İndirimi</span
                        ></strong
                      >
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong
                        ><span style="color: #92D050;"
                          >Kasko Fiyatı 2021</span
                        ></strong
                      >
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">VOLKSWAGEN</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">2012</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;"
                        >GOLF VI 1.6 TDI (105) TR</span
                      >
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">₺147.951,00</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">0%</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">₺1.187,83</span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">HYUNDAİ</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">2008</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;"
                        >ACCENT 1.6 ADMIRE OV (Y)</span
                      >
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">₺68.400,00</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">0%</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">₺1.303,89</span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">RENAULT (OYAK)</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">2016</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;"
                        >CLIO JOY 1.2 16V 75 FAZ1</span
                      >
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">₺110.645,00</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">30%</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">₺785,83</span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">BMW</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">2016</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">116d HATCBACK 1.5 (116)</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">₺276.178,00</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">40%</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">₺1.814,39</span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">OPEL</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">2015</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">ASTRA SEDAN 1.6 115 EDI</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">₺129.227,00</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">50%</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">₺965,59</span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">FORD</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">2013</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;"
                        >FOCUS III TREND 1.6i 125</span
                      >
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">₺141.201,00</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">60%</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">₺1.103,34</span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">FİAT</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">2020</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;"
                        >&nbsp;EGEA HB URBAN PLUS 1.3</span
                      >
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">₺185.462,00</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">60%</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">₺1.448,37</span>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="mt-5">
              **Tabloda yer alan veriler online kasko fiyatı talep edilen
              müşteriler için hazırlanan primlerin ortalamasını yansıtmaktadır.
            </div>
          </v-tab-item>
          <v-tab-item>
            <table>
              <tbody>
                <tr>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong
                        ><span style="color: #92D050;"
                          >Hasarsız Geçirilen Yıl</span
                        ></strong
                      >
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong
                        ><span style="color: #92D050;"
                          >Kasko Hasarsızlık İndirimi Uygulaması</span
                        ></strong
                      >
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong
                        ><span style="color: #92D050;"
                          >Hasarsızlık İndirimi (%)</span
                        ></strong
                      >
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">0</span>
                    </p>
                  </td>
                  <td>
                    <p style="line-height: NaN%;">
                      <span style="color: black;">İlk Poliçe Dönemi</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">0%</span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">1</span>
                    </p>
                  </td>
                  <td>
                    <p style="line-height: NaN%;">
                      <span style="color: black;">1. Yılın Sonunda</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">30%</span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">2</span>
                    </p>
                  </td>
                  <td>
                    <p style="line-height: NaN%;">
                      <span style="color: black;">2. Yılın Sonunda</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">40%</span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">3</span>
                    </p>
                  </td>
                  <td>
                    <p style="line-height: NaN%;">
                      <span style="color: black;">3. Yılın Sonunda</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">50%</span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">4</span>
                    </p>
                  </td>
                  <td>
                    <p style="line-height: NaN%;">
                      <span style="color: black;"
                        >4. Yılın Sonunda ve Daha Sonrasında</span
                      >
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">60%</span>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="mt-5">
              **Kasko hasarsızlık indiriminden yararlanmak için poliçenizi
              düzenli yenilemelisiniz.
            </div>
          </v-tab-item>
        </v-tabs-items>
      </template>
    </v-container>
  </section>
</template>

<script>
export default {
  data () {
    return {
      tab: null,
      currentYear: new Date().getFullYear(),
      buttons: [
        {
          id: 1,
          text: 'Araç Değerine Göre Ortalama Kasko Fiyatları'
        },
        {
          id: 2,
          text: 'Kasko Hasarsızlık İndirimi'
        }
      ]
    }
  }
}
</script>

<style lang="scss">
@import '@/css/variables';
.table {
  table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
    margin: 0;
    overflow: hidden;
    box-sizing: border-box;
    * {
      box-sizing: border-box;
    }
  }
  tbody {
    display: table-row-group;
    vertical-align: middle;
    border-color: inherit;
  }

  th,
  td {
    border: 2px solid #ebeef5;
    box-sizing: border-box;
    min-width: 1em;
    padding: 3px 5px;
    position: relative;
    text-align: center;
  }
  th {
    background-color: $primary;
    font-weight : 400;
    color: #fff;
    padding-top: 6px;
    font-weight: 500;
  }
}
</style>
